import { parseDate } from '@ais-ui/utils';
import { QueryPointResult } from './extractTargetInfo';

export interface DasTargetInfo {
  latitude: number;
  longitude: number;
  trackId: string;
  site: string;
  lat1: string;
  lon1: string;
  lat2: string;
  lon2: string;
  accuracy: string;
  heading1: string;
  heading2: string;
  speed: string;
  nonFilteredCablePosition: string;
  nonFilteredDistFromCable: string;
  priority: string;
  lastOrigin: string;
  lastReportTimestamp: Date | null;
}

export function extractDasTargetInfos(
  result: QueryPointResult
): DasTargetInfo[] {
  const extractedTargetInfos: DasTargetInfo[] = [];

  result?.targetInfo?.forEach((targetInfo) => {
    const dasTargetInfo: DasTargetInfo = {
      latitude: targetInfo.lat,
      longitude: targetInfo.lon,
      trackId: '',
      site: '',
      lat1: '',
      lon1: '',
      lat2: '',
      lon2: '',
      accuracy: '',
      heading1: '',
      heading2: '',
      speed: '',
      nonFilteredCablePosition: '',
      nonFilteredDistFromCable: '',
      priority: '',
      lastOrigin: '',
      lastReportTimestamp: null,
    };

    // Extract values from the values array only
    targetInfo.values?.forEach((value) => {
      switch (value.id) {
        case 'track_id':
          dasTargetInfo.trackId = value.value;
          break;
        case 'site':
          dasTargetInfo.site = value.value;
          break;
        // New IDs for lat/lon
        case 'lat_last_report_1':
        case 'lat_das_last_report_1':
        case 'lat1': // backward compatibility
          if (!dasTargetInfo.lat1) dasTargetInfo.lat1 = value.value;
          break;
        case 'lon_last_report_1':
        case 'lon_das_last_report_1':
        case 'lon1': // backward compatibility
          if (!dasTargetInfo.lon1) dasTargetInfo.lon1 = value.value;
          break;
        case 'lat_last_report_2':
        case 'lat_das_last_report_2':
        case 'lat2': // backward compatibility
          if (!dasTargetInfo.lat2) dasTargetInfo.lat2 = value.value;
          break;
        case 'lon_last_report_2':
        case 'lon_das_last_report_2':
        case 'lon2': // backward compatibility
          if (!dasTargetInfo.lon2) dasTargetInfo.lon2 = value.value;
          break;
        case 'accuracy':
          dasTargetInfo.accuracy = value.value;
          break;
        case 'heading1':
          dasTargetInfo.heading1 = value.value;
          break;
        case 'heading2':
          dasTargetInfo.heading2 = value.value;
          break;
        case 'speed':
          dasTargetInfo.speed = value.value;
          break;
        case 'nonfiltered_cable_position':
          dasTargetInfo.nonFilteredCablePosition = value.value;
          break;
        case 'nonfiltered_dist_from_cable':
          dasTargetInfo.nonFilteredDistFromCable = value.value;
          break;
        case 'priority':
          dasTargetInfo.priority = value.value;
          break;
        case 'lastorigin':
          dasTargetInfo.lastOrigin = value.value;
          break;
        // New IDs for datetime
        case 'datetime_last_report_1':
        case 'datetime_das_last_report_1':
        case 'last_report_timestamp': // backward compatibility
          if (!dasTargetInfo.lastReportTimestamp) {
            dasTargetInfo.lastReportTimestamp = parseDate(value.value);
          }
          break;
      }
    });

    extractedTargetInfos.push(dasTargetInfo);
  });

  return extractedTargetInfos;
}
